"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = require("../../Typography");

var _SidebarSubPanel = _interopRequireDefault(require("./SidebarSubPanel"));

var _Constant = require("../../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 2.4rem;\n  min-height: 181px;\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ReferralItem = (0, _styledComponents.default)(_SidebarSubPanel.default)(_templateObject(), _Constant.Color.GREY_2);

var MarketingReferralItem = function MarketingReferralItem(_ref) {
  var header = _ref.header,
      description = _ref.description,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["header", "description", "children"]);
  return /*#__PURE__*/_react.default.createElement(ReferralItem, rest, /*#__PURE__*/_react.default.createElement(_Typography.Typography.SidebarProductHeader, null, header), /*#__PURE__*/_react.default.createElement(_Typography.Typography.SidebarBody, null, description), children);
};

MarketingReferralItem.propTypes = {
  /** panel header */
  header: _propTypes.default.string.isRequired,

  /** panel description */
  description: _propTypes.default.string.isRequired,

  /** optional elements in a marketing item, i.e. a referral form. */
  children: _propTypes.default.node
};
MarketingReferralItem.defaultProps = {
  children: undefined
};
var _default = MarketingReferralItem;
exports.default = _default;